import h from "react";
import o from "prop-types";
import c from "dayjs";
import { range as M, chunk as y } from "lodash";
import { a as d, u as D, g as H } from "./utils-B8CGXZ5v.es.js";
import { a as u, d as p } from "./propTypes-DVvgo52A.es.js";
import { A as w } from "./ArrowWrapper-DV0yMbb-.es.js";
import { D as C } from "./DateLabel-FP_sGGmJ.es.js";
import { C as S } from "./CalendarUnitButton-Ch_cIohU.es.js";
import './DayPicker.css';const v = "DayPicker-module__row___GUIau", _ = "DayPicker-module__container___XbprV", k = "DayPicker-module__monthCalendar___cwajf", b = "DayPicker-module__weeksContainer___QwcTX", m = {
  row: v,
  container: _,
  monthCalendar: k,
  weeksContainer: b
}, g = (i) => {
  const t = c(new Date(i.year, i.month - 1, 1)), e = [
    ...H(t).map((n) => ({
      disabled: !0,
      text: String(n)
    })),
    ...M(1, t.daysInMonth() + 1).map((n) => ({
      text: String(n),
      disabled: !d(
        ...[
          i.minDate,
          { day: n, month: i.month, year: i.year },
          i.maxDate
        ].filter((l) => l != null)
      ),
      highlight: !!(i.startHighlight && i.endHighlight && i.startHighlight <= n && n <= i.endHighlight),
      endPoint: i.endHighlight === n,
      startPoint: i.startHighlight === n,
      onClick: () => i.onDayClick(n),
      onMouseOver: () => i.onDayHover(n)
    }))
  ], a = e.length % 7 ? 7 - e.length % 7 : 0;
  e.push(
    ...M(a).map((n) => ({
      disabled: !0,
      text: String(n + 1)
    }))
  );
  const r = y(e, 7);
  return /* @__PURE__ */ h.createElement("div", { className: m.monthCalendar }, /* @__PURE__ */ h.createElement(C, { month: i.month, year: i.year }), /* @__PURE__ */ h.createElement("div", { className: m.weeksContainer }, r.map((n, l) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ h.createElement("div", { className: m.row, key: l }, n.map((f) => /* @__PURE__ */ h.createElement(
      S,
      {
        unit: "day",
        rangeMode: i.rangeMode,
        onMouseOut: () => i.onDayHover(null),
        key: f.text,
        ...f
      }
    )))
  ))));
};
g.propTypes = {
  year: o.number.isRequired,
  month: o.number.isRequired,
  onDayClick: o.func.isRequired,
  onDayHover: o.func.isRequired,
  rangeMode: o.bool.isRequired,
  startHighlight: o.number,
  endHighlight: o.number,
  minDate: u,
  maxDate: u
};
g.defaultProps = {
  startHighlight: null,
  endHighlight: null,
  minDate: null,
  maxDate: null
};
class s extends h.Component {
  static initialYearMonth(t, e) {
    const { year: a, month: r } = t || e || {
      year: c().year(),
      month: c().month() + 1
    };
    return { year: a, month: r };
  }
  static lastMonth({ year: t, month: e }) {
    return {
      month: e === 1 ? 12 : e - 1,
      year: e === 1 ? t - 1 : t
    };
  }
  static nextMonth({ year: t, month: e }) {
    return {
      month: e === 12 ? 1 : e + 1,
      year: e === 12 ? t + 1 : t
    };
  }
  static withinOneMonth(t, e) {
    const a = [
      s.lastMonth(t),
      t,
      s.nextMonth(t)
    ];
    for (const r of a)
      if (r.year === e.year && r.month === e.month)
        return !0;
    return !1;
  }
  constructor(t) {
    super(t);
    const { year: e, month: a } = s.initialYearMonth(
      t.start,
      t.end
    );
    this.state = { year: e, month: a, hoveredDate: null };
  }
  UNSAFE_componentWillReceiveProps(t) {
    t.start && (t.start.year !== (this.props.start || {}).year || t.start.month !== (this.props.start || {}).month) && !s.withinOneMonth(t.start, this.state) && this.setState({
      year: t.start.year,
      month: t.start.month
    }), t.end && (t.end.year !== (this.props.end || {}).year || t.end.month !== (this.props.end || {}).month) && !s.withinOneMonth(t.end, this.state) && this.setState({
      year: t.end.year,
      month: t.end.month
    });
  }
  getHighlightedDays({ month: t, year: e }) {
    const { start: a } = this.props;
    if (a && !this.props.rangeMode) {
      const n = a.month === t && a.year === e ? a.day : -1;
      return { startHighlight: n, endHighlight: n };
    }
    const r = this.props.end || this.state.hoveredDate;
    return !a || !r || !d(a, r) || !d(a, { month: t, year: e }) || !d({ month: t, year: e }, r) ? null : {
      startHighlight: a.month === t && a.year === e ? a.day : -1,
      endHighlight: r.month === t && r.year === e ? r.day : 32
    };
  }
  handleClick(t) {
    D(
      t,
      this.props.start,
      this.props.onSetStart,
      this.props.end,
      this.props.onSetEnd,
      this.props.focused,
      this.props.rangeMode
    );
  }
  handleHover(t) {
    this.setState({ hoveredDate: t });
  }
  render() {
    const t = s.lastMonth(this.state), e = s.nextMonth(this.state), a = this.props.rangeMode ? [t, this.state, e] : [this.state];
    return /* @__PURE__ */ h.createElement(
      w,
      {
        onBack: () => this.setState(s.lastMonth),
        hideBack: !d(this.props.minDate || t, t),
        onForward: () => this.setState(s.nextMonth),
        hideForward: !d(e, this.props.maxDate || e),
        rangeMode: this.props.rangeMode
      },
      /* @__PURE__ */ h.createElement(
        "div",
        {
          className: a.length > 1 ? m.container : void 0
        },
        a.map(({ month: r, year: n }) => /* @__PURE__ */ h.createElement(
          g,
          {
            key: r,
            year: n,
            month: r,
            ...this.getHighlightedDays({ month: r, year: n }),
            onDayClick: (l) => this.handleClick({ year: n, month: r, day: l }),
            onDayHover: (l) => this.handleHover(l && { year: n, month: r, day: l }),
            minDate: this.props.minDate,
            maxDate: this.props.maxDate,
            rangeMode: this.props.rangeMode
          }
        ))
      )
    );
  }
}
s.propTypes = {
  focused: o.oneOf(["start", "end"]),
  start: p,
  end: p,
  onSetStart: o.func.isRequired,
  onSetEnd: o.func.isRequired,
  minDate: u,
  maxDate: u,
  rangeMode: o.bool.isRequired
};
s.defaultProps = {
  start: null,
  end: null,
  focused: null,
  minDate: null,
  maxDate: null
};
export {
  s as D
};
